import styled from "@emotion/styled";
import { Link, Paragraph, rem } from "@triumph/design-system";

import { StyledLayoutProps } from "../../../features/common/Layout/Layout.types";

export const PublicLayoutContainer = styled.div<StyledLayoutProps>`
  background: ${({ theme }: any) => theme.colors.background};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 100%;
  min-height: 100%;
`;

export const ContentContainer = styled.div<StyledLayoutProps>`
  display: flex;
  flex-direction: column;
  min-width: ${({ breakpoint }) => (breakpoint === "xs" ? null : rem(464))};
  width: ${({ breakpoint }) => (breakpoint === "xs" ? rem(327) : null)};
  max-width: ${rem(500)};
`;

export const MobileCopyrightContainer = styled.div`
  margin-top: ${rem(24)};
  text-align: center;
`;

export const FooterContainer = styled.div<StyledLayoutProps>`
  display: flex;
  flex-direction: row;
  margin-top: ${({ breakpoint }) => (breakpoint === "xs" ? null : rem(24))};
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  > p,
  a:not(:last-of-type) {
    margin-right: ${rem(12.5)};
  }
`;

export const FooterLink = styled(Link)`
  margin: 0;
`;

export const FooterItem = styled(Paragraph)`
  color: ${({ theme }: any) => theme.colors.greyscale.white};
  margin: 0;
`;

export const FooterDivider = styled.div`
  color: ${({ theme }: any) => theme.colors.greyscale.white};
  border-right: ${({ theme }: any) =>
    `${rem(1)} solid ${theme.colors.greyscale.white}`};
  margin-right: ${rem(12.5)};
  height: ${rem(14)};
`;

export const HeaderContainer = styled.div<StyledLayoutProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: ${rem(40)};
  padding-bottom: ${rem(24)};
`;

export const LogoContainer = styled.div<StyledLayoutProps>`
  height: 100%;
`;

export const ContactUsContainer = styled.div`
  display: flex;
  & a {
    color: ${({ theme }: any) => theme.colors.greyscale.white} !important;
    text-decoration: none;
  }
  font-weight: 600;
  margin: ${rem(8)} ${rem(16)} 0 0;
`;
